import * as yup from 'yup'

export const requisitionItemSchema = yup.object({
  brand_name: yup.string().required('Brand name is required'),
  generic_name: yup.string().required('Generic name is required'),
  product_id: yup.number(),
  requested_quantity: yup
    .number()
    .typeError('Requested quantity is required')
    .min(1, 'Requested quantity must be at least 1')
    .required('Requested quantity is required'),
  strength: yup.string().required('Strength is required')
})

export const createRequisitionSchema = yup.object({
  note: yup.string().optional(),
  items: yup.array().of(requisitionItemSchema).min(1, 'At least one drug is required').required(),
  transfer_mode: yup
    .string()
    .required('Transfer mode is required')
    .oneOf(['ward', 'facility_inventory'], 'Select a valid transfer mode'),
  unit_id: yup.string().when('transfer_mode', {
    is: 'ward',
    then: schema => schema.trim().min(1, 'Ward/Unit is required').required(),
    otherwise: schema => schema.optional()
  }),
  inventory_location_id: yup.string().when('transfer_mode', {
    is: 'facility_inventory',
    then: schema => schema.trim().min(1, 'Facility inventory is required').required(),
    otherwise: schema => schema.optional()
  })
})

export const reviewRequisitionItemSchema = yup.object({
  approved_quantity: yup.string().optional(),
  id: yup.string().required('Item id is required'),
  status: yup.string().required('Status is required')
})

export const reviewRequisitionSchema = yup.object({
  items: yup.array().of(reviewRequisitionItemSchema).min(1, 'At least one item is required').required(),
  note: yup.string().optional()
})
